import React from 'react'
import { TextField } from 'hhsoig-design-system-core'

export const MetricHeightField = ({ field, ...props }) => (
  <div className="ds-l-form-row ds-u-align-items--end">
    <div className="ds-l-col--auto">
      <TextField type="number" size="medium" {...props} {...field} />
    </div>
    <div className="ds-l-col--auto ds-u-margin-bottom--2">
      <span>centimeters</span>
    </div>
  </div>
)
